import React, { useEffect } from 'react'
import Client from '../components/Client'
import { useAppLayoutResetter } from '@caudena/core/state'
import { useParams } from '@caudena/core/Router/router'

export const PageClient = () => {
  const { id } = useParams<{ id: string }>()
  const resetLayout = useAppLayoutResetter()
  useEffect(() => {
    resetLayout()
  }, [])
  return <Client id={id} />
}
